export default __webpack_public_path__ + "locales/en/FormGallery.json?hash=4ffe70adb4d3a26b0a4a5f0beb1780be";